import './team-block.scss';

export default () => {

};
